<div class="content">
  <div class="brand-title">
    <img src="/assets/img/fleetoperate_logo.jpg" />
  </div>

  <div >
    <div class="title">Looks like you tried to login to the wrong <span>FleetOperate</span> application.</div>
    <div class="margin-top-md message">
      Please <a class="app-link" href="{{ driverUrl }}">click here</a> to login to driver application.
    </div>
  </div>
  <div  class="footer">
    <div>
      <span class="copy-right">&copy; Copyright {{ copyrightYear }} FleetOperate</span>
    </div>
    <div >
      <div class="contact default-background">
        <a (click)="onOpenContactUsDialog()">Contact</a> |
        <a href="{{ fleetOperateUrl }}" target="_blank">fleetoperate.com</a>
      </div>
    </div>
  </div>
</div>
